








import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { MessageInterface } from '../../interfaces/message/message.interface';
import ItemMessage from '@/components/message/MessageItem.vue';

@Component({
  components: {
    ItemMessage,
  },
})
export default class MessageCollection extends Vue {
  @Prop() readonly messages!: MessageInterface[];
}
